import { createContext, useContext, useState } from 'react'

const UnityUnloadContext = createContext<any>(null)

export const UnityUnloadContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [unload, setUnload] = useState<{unload: (() => Promise<void>) | null}>({unload: null})

  const unloadSetter = (val: (() => Promise<void>) | null) => setUnload({unload: val})


  return <UnityUnloadContext.Provider value={{ unload, unloadSetter }}>{children}</UnityUnloadContext.Provider>
}

export const useUnityUnloadContext = () => useContext<IUseData>(UnityUnloadContext)

interface IUseData {
  unloadSetter: (v: (() => Promise<void>) | null) => void
  unload: {unload: (() => Promise<void>) | null}
}
